import React, { useState, useEffect } from "react";
import { Button, Form, Message } from "semantic-ui-react";
import { connect } from "react-redux";

import { firebase } from "../../../../firebase";
import { updateProfile } from "../../../../redux/actions/auth";

import moment from "moment-timezone";
import {
  validateOnlyLetters,
  validateEmail,
  errorMsgs,
} from "../../../../commons/functions/formValidations";

import "./styles.css";

const AccountDetails = ({ auth, updateProfile, authentication }) => {
  const INITIAL_USER = {
    name: auth.profile.name,
    lastName: auth.profile.lastName,
    birthday: auth.profile.birthday,
    gender: auth.profile.gender,
    email: auth.profile.email,
  };
  const [user, setUser] = useState(INITIAL_USER);
  const [disabled, setDisabled] = useState(true);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [provider, setProvider] = useState("");
  const [isValid, setIsValid] = useState({
    name: { valid: true, error: "" },
    lastName: { valid: true, error: "" },
    email: { valid: true, error: "" },
    birthday: { valid: true, error: "" },
    gender: { valid: true, error: "" },
  });

  useEffect(() => {
    const isValidForm = Object.values(isValid).every((element) =>
      Boolean(element.valid)
    );
    const isUser = Object.values(user).every((element) => Boolean(element));
    setProvider(auth.providerData[0].providerId);
    isUser &&
    isValidForm &&
    user.password === user.confirmPassword &&
    provider === "password"
      ? setDisabled(false)
      : setDisabled(true);
  }, [user, auth, provider, isValid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    switch (name) {
      case "name":
      case "lastName":
        validateOnlyLetters(value)
          ? validateForm(name, true, "")
          : value === ""
          ? validateForm(name, false, errorMsgs.required)
          : value.length === 1
          ? validateForm(name, false, errorMsgs.atLeastTwo)
          : validateForm(name, false, errorMsgs.lettersOnly);
        break;
      case "email":
        validateEmail(value)
          ? validateForm(name, true, "")
          : value === ""
          ? validateForm(name, false, errorMsgs.required)
          : validateForm(name, false, errorMsgs.email);
        break;
      default:
        break;
    }
  };
  const validateForm = (name, bool, error) => {
    setIsValid((prevState) => ({
      ...prevState,
      [name]: { valid: bool, error },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError("");
      const { name, lastName, birthday, gender, email } = user;
      const token = await firebase.auth().currentUser.getIdToken();
      await updateProfile({
        token,
        name,
        lastName,
        birthday,
        gender,
        email,
        authentication,
      });
      setSuccess(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  return (
    <div className="account-details-container">
      <Form
        error={Boolean(error)}
        onSubmit={handleSubmit}
        loading={loading}
        success={success}
      >
        <Message error header="Oops!" content={error || ""} />
        <Message
          success
          icon="check"
          header="Éxito"
          content="Su perfil ha sido actualizado."
        />

        <Form.Input
          label={"Nombre"}
          placeholder="Nombre"
          name="name"
          onChange={handleChange}
          value={user.name}
          type="text"
          disabled={provider !== "password"}
        />
        <p className="account-details-input-error">
          {!isValid.name.valid && isValid.name.error}
        </p>

        <Form.Input
          label="Apellido"
          placeholder="Apellido"
          name="lastName"
          onChange={handleChange}
          value={user.lastName}
          type="text"
          disabled={provider !== "password"}
        />
        <p className="account-details-input-error">
          {!isValid.lastName.valid && isValid.lastName.error}
        </p>
        <Form.Input
          label="Correo electrónico"
          placeholder="Correo electrónico"
          name="email"
          onChange={handleChange}
          value={user.email}
          type="email"
          disabled={true}
        />
        <p className="account-details-input-error">
          {!isValid.email.valid && isValid.email.error}
        </p>

        <Form.Input
          label="Fecha de cumpleaños"
          type="date"
          value={moment(user.birthday).format("YYYY-MM-DD")}
          onChange={handleChange}
          name="birthday"
          disabled={provider !== "password"}
        />
        <Form.Group inline>
          <Form.Input
            type="radio"
            name="gender"
            label="Hombre"
            value="male"
            checked={user.gender === "male"}
            onChange={handleChange}
            disabled={provider !== "password"}
          />
          <Form.Input
            type="radio"
            label="Mujer"
            name="gender"
            value="female"
            checked={user.gender === "female"}
            onChange={handleChange}
            disabled={provider !== "password"}
          />
        </Form.Group>
        <Button
          type="submit"
          color="black"
          content="Actualizar"
          disabled={disabled || loading}
        />
      </Form>
      {provider !== "password" ? (
        provider === "" ? null : (
          <Message
            warning
            icon="ban"
            header="¡Lo sentimos!"
            content={`Usted inició sesión con ${provider}, no puede modificar su información.`}
          />
        )
      ) : null}
    </div>
  );
};

const mapStateToProps = ({ firebase: { profile, auth } }) => ({
  ...profile,
  auth,
});

export default connect(mapStateToProps, { updateProfile })(AccountDetails);
